import { render, staticRenderFns } from "./sp-location.vue?vue&type=template&id=530360b2"
import script from "./sp-location.vue?vue&type=script&lang=js"
export * from "./sp-location.vue?vue&type=script&lang=js"
import style0 from "./sp-location.vue?vue&type=style&index=0&id=530360b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OptimizedImage: require('/app/components/ui/OptimizedImage.vue').default})
